import React from 'react'
import { generateDateString } from 'utils/time'
import { formatAndSanitizeHTML } from 'utils/misc'
import { Button } from 'components/UIElements'

const Announcement = ({
  announcement,
  strings,
  isOpen,
  onToggle
}) => {
  const {
    id,
    sent,
    title,
    content,
    read,
    start_date
  } = announcement

  const isUnread = !read

  return (
    <Button
      key={`announcement-${id}`}
      className={`announcement${isUnread ? ' unread' : ''}${isOpen ? ' open' : ' close'
        }`}
      onClick={onToggle}>
      {isUnread && <div className='unread-dot' />}
      <p className='flexed'>
        <span>{strings.study_team}</span>
        <span>{generateDateString(sent || start_date, strings)}</span>
      </p>
      <h4>{title}</h4>
      {isOpen && (
        <p
          role='presentation'
          onClick={(e) => e.stopPropagation()}
          className='announcement-content'
          dangerouslySetInnerHTML={{
            __html: formatAndSanitizeHTML(content)
          }}
        />
      )}
    </Button>
  )
}

export default Announcement
